module.exports = {"469001100":"通什镇","469001101":"南圣镇","469001102":"毛阳镇","469001103":"番阳镇","469001200":"畅好乡","469001201":"毛道乡","469001202":"水满乡","469001400":"畅好农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469001.json
// module id = 2019
// module chunks = 0